import { createContext } from "react";
import type { LineData } from "components/charting/types/Chart.types";
import type { Variants } from "types/exercise";
import type { OneRepMaxAggregationUnit, OneRepMaxProgressEntry } from "../../helpers/OneRepMaxChartHelpers";

export interface OneRepMaxChartLinesContextType {
  lines: LineData[];
  aggregationUnit: OneRepMaxAggregationUnit;
  spanInDays: number;
  entries: OneRepMaxProgressEntry[];
  getLineColor: (variant?: Variants | null) => string;
}

const OneRepMaxChartLinesContext = createContext<OneRepMaxChartLinesContextType | undefined>(undefined);
OneRepMaxChartLinesContext.displayName = "OneRepMaxChartLinesContext";

export default OneRepMaxChartLinesContext;
